import {remCalc} from '_themeUtils'
import textStyles from 'overrides/app/theme/foundations/textStyles'

const productFindInBoutique = {
    ProductFindInBoutique: {
        baseStyle: () => ({
            container: {
                gap: 'spacing.10',
            },
            drawerHeaderWrapper: {
                gap: 'spacing.8',
            },
            drawerTitle: {
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'normal',
                alignSelf: 'flex-start',

                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            drawerSubtitle: {
                textTransform: 'none',
                textStyle: 'paragraphXl',
                fontWeight: 'light',
                alignSelf: 'flex-start',

                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            productInfoContainer: {
                w: '100%',
                alignItems: 'flex-start',
                gap: 'spacing.1',
            },
            productInfo: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
            chooseCountrySubtitle: {
                textStyle: 'paragraphLg',
            },
            infoText: {
                textStyle: 'paragraphMd',
                textAlign: 'left',
                w: '100%',
            },
            filterAvailableBoutiquesCheckbox: {
                mt: 'spacing.5',
                mb: 'spacing.5',
            },
            filterAvailableBoutiques: {
                textStyle: 'paragraphSm',
            },
            boutiqueItemContainer: {
                w: '100%',
                py: 'spacing.2',
            },
            boutiqueItemWrapper: {},
            boutiqueItemInfoContainer: {
                w: '100%',
                justifyContent: 'space-between',
            },
            boutiqueItemInfo: {
                alignItems: 'flex-start',
                gap: 'spacing.0.5',
            },
            boutiqueItemOpeningMobile: {
                alignItems: 'flex-start',
                gap: 'spacing.0.5',
                pb: 'spacing.1',
            },
            boutiqueItemName: {
                textStyle: 'paragraphLg',
                fontWeight: 'normal',
            },
            boutiqueItemAvailability: {
                textAlign: 'right',
            },
            boutiqueItemUnavailable: {
                color: 'color.text.error',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemAvailableLow: {
                color: 'color.text.alert',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemAvailable: {
                color: 'color.text.success',
                textStyle: 'paragraphSm',
                fontWeight: 'normal',
            },
            boutiqueItemButtonsContainer: {
                w: '100%',
                justifyContent: 'space-between',
                gap: 'spacing.6',
                flexDirection: {base: 'column', md: 'row'},
            },
            boutiqueItemLinks: {
                w: '100%',
            },
            boutiqueItemCallButton: {
                p: 'spacing.3',
                h: '100%',
            },
            boutiqueItemButtonsText: {
                textStyle: 'paragraphMd',
                textTransform: 'uppercase',
            },
            boutiqueItemBookButton: {
                h: '100%',
                p: {base: 0, md: 'spacing.7'},
            },
        }),
    },
}

export default productFindInBoutique
